import type { SVGProps } from 'react';
import * as React from 'react';

const ChangeTrackerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="product-logo/change-tracker">
      <g id="Group 17">
        <path
          id="Vector"
          d="M1 6.09294V16.4919C1 18.6132 2.72164 20.3349 4.84294 20.3349H12.4981C12.7133 20.3349 12.8824 20.504 12.8824 20.7192V22.5177C12.8824 22.8482 13.2667 23.0249 13.5126 22.8097L23.8655 13.9786C24.1345 13.7481 23.9731 13.3023 23.6195 13.3023H9.07017C8.43224 13.3023 7.91729 12.7873 7.91729 12.1494V10.4355C7.91729 9.79753 8.43224 9.28258 9.07017 9.28258H13.6433C14.2812 9.28258 14.7961 9.79753 14.7961 10.4355V10.4739C14.7961 10.6891 14.9652 10.8582 15.1804 10.8582H21.4291C21.6443 10.8582 21.8134 10.6891 21.8134 10.4739V6.09294C21.8134 3.97164 20.0917 2.25 17.9704 2.25H4.84294C2.72164 2.25 1 3.97164 1 6.09294Z"
          fill="#2D2D2D"
        />
        <g id="Intersect">
          <path
            d="M8.2347 9.64009C8.03789 9.84679 7.917 10.1271 7.917 10.4358V12.1497C7.91712 12.7875 8.43241 13.302 9.07026 13.302H23.6196C23.9731 13.302 24.1344 13.7486 23.8654 13.9792L13.5123 22.8098C13.2664 23.0248 12.8827 22.8478 12.8827 22.5174V20.719C12.8826 20.5039 12.7131 20.3352 12.498 20.3352H4.84293C2.84505 20.3352 1.20132 18.8078 1.01686 16.8579L8.2347 9.64009Z"
            fill="#525252"
          />
          <path
            d="M8.34644 9.5371C8.32051 9.558 8.29563 9.58014 8.27162 9.60317L8.33963 9.53613L8.34644 9.5371Z"
            fill="#525252"
          />
        </g>
        <path
          id="Intersect_2"
          d="M17.9705 2.25024C20.0917 2.25031 21.8131 3.97162 21.8131 6.09283V10.4737C21.8131 10.6888 21.6444 10.8583 21.4293 10.8584H15.1802C14.9651 10.8583 14.7964 10.6888 14.7964 10.4737V10.4358C14.7964 9.79785 14.2811 9.28252 13.6431 9.28252H9.06992C8.76679 9.28258 8.49233 9.39995 8.28683 9.59051L8.28586 9.58953L15.6261 2.25024H17.9705Z"
          fill="#080808"
        />
      </g>
    </g>
  </svg>
);
export default ChangeTrackerIcon;
